import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      opacity: "0.4",
      d: "M13.24 2C13.71 2 14.1 2.38 14.1 2.86V21.15C14.1 21.62 13.72 22.01 13.24 22.01C7.34999 22.01 3.23999 17.9 3.23999 12.01C3.23999 6.12 7.35999 2 13.24 2Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M20.5399 11.54L17.6999 8.69C17.4099 8.4 16.9299 8.4 16.6399 8.69C16.3499 8.98 16.3499 9.46 16.6399 9.75L18.1999 11.31H8.62988C8.21988 11.31 7.87988 11.65 7.87988 12.06C7.87988 12.47 8.21988 12.81 8.62988 12.81H18.1999L16.6399 14.37C16.3499 14.66 16.3499 15.14 16.6399 15.43C16.7899 15.58 16.9799 15.65 17.1699 15.65C17.3599 15.65 17.5499 15.58 17.6999 15.43L20.5399 12.58C20.8299 12.3 20.8299 11.83 20.5399 11.54Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_3)
  ]))
}
}

})